import PropTypes from 'prop-types';

const AuthPropTypes = {
  setupInterceptors: PropTypes.func,
  checkSsoLoginIsAlive: PropTypes.func,
};

export default AuthPropTypes;
